import { overviewScoreSquares } from "./OverviewScoreSquares";

export const templatePages3Levels = [
	{
		topMargin: 50.0,
		rightMargin: 0.0,
		bottomMargin: 0.0,
		leftMargin: 0.0,
		blocks: [
			{
				type: "text",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 495.0,
					unit: "POINT"
				},
				height: {
					value: 40.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "excel",
					text: ""
				},
				font: "liberationsans-bold",
				fontSize: 26.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "CENTER",
				valign: "TOP"
			},
			{
				type: "image",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 40.0,
					unit: "POINT"
				},
				width: {
					value: 100.0,
					unit: "POINT"
				},
				height: {
					value: 50.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				image: null
			},
			{
				type: "text",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 90.0,
					unit: "POINT"
				},
				width: {
					value: 100.0,
					unit: "POINT"
				},
				height: {
					value: 12.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: ""
				},
				font: "liberationsans-regular",
				fontSize: 8.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 102.0,
					unit: "POINT"
				},
				width: {
					value: 100.0,
					unit: "POINT"
				},
				height: {
					value: 12.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: ""
				},
				font: "liberationsans-regular",
				fontSize: 8.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 160.0,
					unit: "POINT"
				},
				y: {
					value: 40.0,
					unit: "POINT"
				},
				width: {
					value: 275.0,
					unit: "POINT"
				},
				height: {
					value: 35.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "excel",
					text: ""
				},
				font: "liberationsans-regular",
				fontSize: 20.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "CENTER",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 160.0,
					unit: "POINT"
				},
				y: {
					value: 80.0,
					unit: "POINT"
				},
				width: {
					value: 275.0,
					unit: "POINT"
				},
				height: {
					value: 25.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "field",
					jsonPath: '$.information.fields[?(@.name == "Naam student")].value'
				},
				font: "liberationsans-regular",
				fontSize: 16.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "CENTER",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 160.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 25.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Vooruitgang activiteiten"
				},
				font: "liberationsans-regular",
				fontSize: 16.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "row",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 185.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				columnSizes: [25.0, 167.5, 30.0],
				cells: [
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: [0.75, 0.75, 0.75]
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 167.5,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "static",
							text: "Aantal activiteiten"
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "LEFT",
						valign: "MIDDLE"
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 30.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*]"
								}
							]
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "RIGHT",
						valign: "MIDDLE"
					}
				]
			},
			{
				type: "row",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 200.0,
					unit: "POINT"
				},
				width: {
					value: 400.0,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				columnSizes: [25.0, 167.5, 30.0],
				cells: [
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: [0.53, 0.8, 0.98]
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 167.5,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "static",
							text: "Aantal beoordeelde activiteiten"
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "LEFT",
						valign: "MIDDLE"
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 30.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..[?((@.score && @.score != '') || @.offered == 'true' || @.achieved == 'true')]'"
								}
							]
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "RIGHT",
						valign: "MIDDLE"
					}
				]
			},
			{
				type: "row",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 215.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				columnSizes: [25.0, 167.5, 30.0],
				cells: [
					null,
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 167.5,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "static",
							text: "Aantal beoordelingen"
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "LEFT",
						valign: "MIDDLE"
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 30.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*].properties.*"
								}
							]
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "RIGHT",
						valign: "MIDDLE"
					}
				]
			},
			{
				type: "chart",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 245.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 40.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				chartType: "PROGRESS",
				series: [
					{
						type: "single",
						value: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*].latestProperties..[?((@.score && @.score != '') || @.offered == 'true' || @.achieved == 'true')]'"
								}
							]
						},
						color: [0.53, 0.8, 0.98]
					},
					{
						type: "single",
						value: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										"$.evaluation.criteria[*].subsections[*].subsections[*]"
								}
							]
						},
						color: [0.75, 0.75, 0.75]
					}
				],
				font: "liberationsans-regular",
				fontSize: 8.0,
				fontColor: [0.0, 0.0, 0.0]
			},
			{
				type: "text",
				x: {
					value: 322.5,
					unit: "POINT"
				},
				y: {
					value: 160.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 25.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Vooruitgang competenties"
				},
				font: "liberationsans-regular",
				fontSize: 16.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "row",
				x: {
					value: 322.5,
					unit: "POINT"
				},
				y: {
					value: 185.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				columnSizes: [25.0, 167.5, 30.0],
				cells: [
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: [0.75, 0.75, 0.75]
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 167.5,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "static",
							text: "Aantal competenties"
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "LEFT",
						valign: "MIDDLE"
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 30.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										'$.evaluation.criteria[*].subsections[*].subsections[?(@.type == "competence")]'
								}
							]
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "RIGHT",
						valign: "MIDDLE"
					}
				]
			},
			{
				type: "row",
				x: {
					value: 322.5,
					unit: "POINT"
				},
				y: {
					value: 200.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 15.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: null,
				filter: null,
				columnSizes: [25.0, 167.5, 30.0],
				cells: [
					{
						type: "shape",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 15.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						shape: "SQUARE",
						fillColor: [0.53, 0.8, 0.98]
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 167.5,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "static",
							text: "Aantal aangeboden competenties"
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "LEFT",
						valign: "MIDDLE"
					},
					{
						type: "text",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 30.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						text: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										'$.evaluation.criteria[*].subsections[*].subsections[?(@.type == "competence")].latestProperties..[?(@.offered == "true")]'
								}
							]
						},
						font: "liberationsans-regular",
						fontSize: 10.0,
						fontColor: [0.0, 0.0, 0.0],
						halign: "RIGHT",
						valign: "MIDDLE"
					}
				]
			},
			{
				type: "chart",
				x: {
					value: 322.5,
					unit: "POINT"
				},
				y: {
					value: 245.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 40.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				chartType: "PROGRESS",
				series: [
					{
						type: "single",
						value: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										'$.evaluation.criteria[*].subsections[*].subsections[?(@.type == "competence")].latestProperties..[?(@.offered == "true")]'
								}
							]
						},
						color: [0.53, 0.8, 0.98]
					},
					{
						type: "single",
						value: {
							type: "function",
							function: "count",
							arguments: [
								{
									type: "field",
									jsonPath:
										'$.evaluation.criteria[*].subsections[*].subsections[?(@.type == "competence")]'
								}
							]
						},
						color: [0.75, 0.75, 0.75]
					}
				],
				font: "liberationsans-regular",
				fontSize: 8.0,
				fontColor: [0.0, 0.0, 0.0]
			},
			{
				type: "text",
				x: {
					value: 50.0,
					unit: "POINT"
				},
				y: {
					value: 350.0,
					unit: "POINT"
				},
				width: {
					value: 222.5,
					unit: "POINT"
				},
				height: {
					value: 25.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Overzicht scores"
				},
				font: "liberationsans-regular",
				fontSize: 16.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				absolutePosition: true,
				condition: null,
				filter: null,
				height: {
					unit: "POINT",
					value: 222.5
				},
				loop: null,
				scoreAggregation: "LATEST",
				type: "rated-competences-chart",
				width: {
					unit: "POINT",
					value: 495.0
				},
				x: {
					unit: "POINT",
					value: 50.0
				},
				y: {
					unit: "POINT",
					value: 375.0
				}
			}
		]
	},
	{
		topMargin: 50.0,
		rightMargin: 50.0,
		bottomMargin: 50.0,
		leftMargin: 50.0,
		blocks: [
			{
				type: "composite",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 0.0,
					unit: "POINT"
				},
				width: {
					value: 495.0,
					unit: "POINT"
				},
				height: {
					value: 0.0,
					unit: "POINT"
				},
				absolutePosition: false,
				condition: null,
				loop: {
					type: "field",
					jsonPath: "$.evaluation.criteria"
				},
				filter: {
					type: "field",
					jsonPath:
						'$.subsections..subsections..latestProperties..[?(@.score || @.offered == "true" || @.achieved == "true")]'
				},
				blocks: [
					{
						type: "row",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 0.0,
							unit: "POINT"
						},
						width: {
							value: 495.0,
							unit: "POINT"
						},
						height: {
							value: 15.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: null,
						filter: null,
						columnSizes: [40.0, 455.0],
						cells: [
							{
								type: "text",
								x: {
									value: 0.0,
									unit: "POINT"
								},
								y: {
									value: 0.0,
									unit: "POINT"
								},
								width: {
									value: 40.0,
									unit: "POINT"
								},
								height: {
									value: 15.0,
									unit: "POINT"
								},
								absolutePosition: false,
								condition: null,
								loop: null,
								filter: null,
								text: {
									type: "function",
									function: "int",
									arguments: [
										{
											type: "function",
											function: "+",
											arguments: [
												{
													type: "dynamic",
													expression: "{index}"
												},
												{
													type: "static",
													text: "1"
												}
											]
										}
									]
								},
								font: "liberationsans-bold",
								fontSize: 14.0,
								fontColor: [0.0, 0.0, 0.0],
								halign: "LEFT",
								valign: "TOP"
							},
							{
								type: "text",
								x: {
									value: 0.0,
									unit: "POINT"
								},
								y: {
									value: 0.0,
									unit: "POINT"
								},
								width: {
									value: 455.0,
									unit: "POINT"
								},
								height: {
									value: 15.0,
									unit: "POINT"
								},
								absolutePosition: false,
								condition: null,
								loop: null,
								filter: null,
								text: {
									type: "field",
									jsonPath: "#.name"
								},
								font: "liberationsans-bold",
								fontSize: 14.0,
								fontColor: [0.0, 0.0, 0.0],
								halign: "CENTER",
								valign: "TOP"
							}
						]
					},
					{
						type: "composite",
						x: {
							value: 0.0,
							unit: "POINT"
						},
						y: {
							value: 15.0,
							unit: "POINT"
						},
						width: {
							value: 495.0,
							unit: "POINT"
						},
						height: {
							value: 0.0,
							unit: "POINT"
						},
						absolutePosition: false,
						condition: null,
						loop: {
							type: "field",
							jsonPath: "#.subsections"
						},
						filter: {
							type: "field",
							jsonPath:
								'$.subsections..latestProperties..[?(@.score || @.offered == "true" || @.achieved == "true")]'
						},
						blocks: [
							{
								type: "row",
								x: {
									value: 0.0,
									unit: "POINT"
								},
								y: {
									value: 0.0,
									unit: "POINT"
								},
								width: {
									value: 495.0,
									unit: "POINT"
								},
								height: {
									value: 15.0,
									unit: "POINT"
								},
								absolutePosition: false,
								condition: null,
								loop: null,
								filter: null,
								columnSizes: [40.0, 455.0],
								cells: [
									{
										type: "text",
										x: {
											value: 0.0,
											unit: "POINT"
										},
										y: {
											value: 0.0,
											unit: "POINT"
										},
										width: {
											value: 40.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: null,
										filter: null,
										text: {
											type: "function",
											function: "concat",
											arguments: [
												{
													type: "function",
													function: "int",
													arguments: [
														{
															type: "function",
															function: "+",
															arguments: [
																{
																	type: "dynamic",
																	expression:
																		"{index~1}"
																},
																{
																	type: "static",
																	text: "1"
																}
															]
														}
													]
												},
												{
													type: "static",
													text: "."
												},
												{
													type: "function",
													function: "int",
													arguments: [
														{
															type: "function",
															function: "+",
															arguments: [
																{
																	type: "dynamic",
																	expression:
																		"{index}"
																},
																{
																	type: "static",
																	text: "1"
																}
															]
														}
													]
												}
											]
										},
										font: "liberationsans-bold",
										fontSize: 12.0,
										fontColor: [0.0, 0.0, 0.0],
										halign: "LEFT",
										valign: "TOP"
									},
									{
										type: "text",
										x: {
											value: 0.0,
											unit: "POINT"
										},
										y: {
											value: 0.0,
											unit: "POINT"
										},
										width: {
											value: 455.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: null,
										filter: null,
										text: {
											type: "field",
											jsonPath: "#.name"
										},
										font: "liberationsans-bold",
										fontSize: 12.0,
										fontColor: [0.0, 0.0, 0.0],
										halign: "LEFT",
										valign: "TOP"
									}
								]
							},
							{
								type: "composite",
								x: {
									value: 0.0,
									unit: "POINT"
								},
								y: {
									value: 15.0,
									unit: "POINT"
								},
								width: {
									value: 495.0,
									unit: "POINT"
								},
								height: {
									value: 0.0,
									unit: "POINT"
								},
								absolutePosition: false,
								condition: null,
								loop: {
									type: "field",
									jsonPath: "#.subsections"
								},
								filter: {
									type: "field",
									jsonPath:
										"$.latestProperties..[?(@.score || @.achieved == 'true')]"
								},
								blocks: [
									{
										type: "row",
										x: {
											value: 0.0,
											unit: "POINT"
										},
										y: {
											value: 0.0,
											unit: "POINT"
										},
										width: {
											value: 495.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: null,
										filter: null,
										columnSizes: [40.0, 455.0],
										cells: [
											{
												type: "text",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 40.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												text: {
													type: "function",
													function: "concat",
													arguments: [
														{
															type: "function",
															function: "int",
															arguments: [
																{
																	type: "function",
																	function:
																		"+",
																	arguments: [
																		{
																			type: "dynamic",
																			expression:
																				"{index~2}"
																		},
																		{
																			type: "static",
																			text: "1"
																		}
																	]
																}
															]
														},
														{
															type: "static",
															text: "."
														},
														{
															type: "function",
															function: "concat",
															arguments: [
																{
																	type: "function",
																	function:
																		"int",
																	arguments: [
																		{
																			type: "function",
																			function:
																				"+",
																			arguments:
																				[
																					{
																						type: "dynamic",
																						expression:
																							"{index~1}"
																					},
																					{
																						type: "static",
																						text: "1"
																					}
																				]
																		}
																	]
																},
																{
																	type: "static",
																	text: "."
																},
																{
																	type: "function",
																	function:
																		"int",
																	arguments: [
																		{
																			type: "function",
																			function:
																				"+",
																			arguments:
																				[
																					{
																						type: "dynamic",
																						expression:
																							"{index}"
																					},
																					{
																						type: "static",
																						text: "1"
																					}
																				]
																		}
																	]
																}
															]
														}
													]
												},
												font: "liberationsans-bold",
												fontSize: 11.0,
												fontColor: [0.0, 0.0, 0.0],
												halign: "LEFT",
												valign: "TOP"
											},
											{
												type: "text",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 455.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												text: {
													type: "field",
													jsonPath: "#.name"
												},
												font: "liberationsans-bold",
												fontSize: 11.0,
												fontColor: [0.0, 0.0, 0.0],
												halign: "LEFT",
												valign: "TOP"
											}
										]
									},
									{
										type: "text",
										x: {
											value: 40.0,
											unit: "POINT"
										},
										y: {
											value: 15.0,
											unit: "POINT"
										},
										width: {
											value: 455.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: null,
										filter: null,
										text: {
											type: "static",
											text: "Evaluaties"
										},
										font: "liberationsans-bold",
										fontSize: 10.0,
										fontColor: [0.0, 0.0, 0.0],
										halign: "CENTER",
										valign: "TOP"
									},
									{
										type: "row",
										x: {
											value: 40.0,
											unit: "POINT"
										},
										y: {
											value: 30.0,
											unit: "POINT"
										},
										width: {
											value: 455.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: {
											type: "field",
											jsonPath: "#.properties"
										},
										filter: {
											type: "field",
											jsonPath:
												"$.[?((@.score && @.score != '') || @.achieved == 'true')]"
										},
										columnSizes: [340.0, 20.0, 95.0],
										cells: [
											{
												type: "composite",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 340.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												blocks: [
													{
														type: "text",
														x: {
															value: 0.0,
															unit: "POINT"
														},
														y: {
															value: 0.0,
															unit: "POINT"
														},
														width: {
															value: 340.0,
															unit: "POINT"
														},
														height: {
															value: 15.0,
															unit: "POINT"
														},
														absolutePosition: false,
														condition: {
															type: "function",
															function: "neq",
															arguments: [
																{
																	type: "function",
																	function:
																		"count",
																	arguments: [
																		{
																			type: "field",
																			jsonPath:
																				"#.[?(@.date)]"
																		}
																	]
																},
																{
																	type: "static",
																	text: "0"
																}
															]
														},
														loop: null,
														filter: null,
														text: {
															type: "function",
															function:
																"formatDate",
															arguments: [
																{
																	type: "function",
																	function:
																		"date",
																	arguments: [
																		{
																			type: "field",
																			jsonPath:
																				"#.date"
																		},
																		{
																			type: "static",
																			text: "dd/MM/yyyy"
																		}
																	]
																},
																{
																	type: "static",
																	text: "dd MMMM yyyy"
																},
																{
																	type: "static",
																	text: "nl"
																}
															]
														},
														font: "liberationsans-regular",
														fontSize: 10.0,
														fontColor: [
															0.0, 0.0, 0.0
														],
														halign: "LEFT",
														valign: "MIDDLE"
													},
													{
														type: "text",
														x: {
															value: 0.0,
															unit: "POINT"
														},
														y: {
															value: 0.0,
															unit: "POINT"
														},
														width: {
															value: 340.0,
															unit: "POINT"
														},
														height: {
															value: 15.0,
															unit: "POINT"
														},
														absolutePosition: false,
														condition: {
															type: "function",
															function: "eq",
															arguments: [
																{
																	type: "function",
																	function:
																		"count",
																	arguments: [
																		{
																			type: "field",
																			jsonPath:
																				"#.[?(@.date)]"
																		}
																	]
																},
																{
																	type: "static",
																	text: "0"
																}
															]
														},
														loop: null,
														filter: null,
														text: {
															type: "function",
															function:
																"formatDate",
															arguments: [
																{
																	type: "function",
																	function:
																		"date",
																	arguments: [
																		{
																			type: "dynamic",
																			expression:
																				"{key}"
																		},
																		{
																			type: "static",
																			text: "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"
																		}
																	]
																},
																{
																	type: "static",
																	text: "dd MMMM yyyy"
																},
																{
																	type: "static",
																	text: "nl"
																}
															]
														},
														font: "liberationsans-regular",
														fontSize: 10.0,
														fontColor: [
															0.0, 0.0, 0.0
														],
														halign: "LEFT",
														valign: "MIDDLE"
													},
													{
														type: "row",
														x: {
															value: 0.0,
															unit: "POINT"
														},
														y: {
															value: 15.0,
															unit: "POINT"
														},
														width: {
															value: 340.0,
															unit: "POINT"
														},
														height: {
															value: 0.0,
															unit: "POINT"
														},
														absolutePosition: false,
														condition: {
															type: "function",
															function: "eq",
															arguments: [
																{
																	type: "function",
																	function:
																		"count",
																	arguments: [
																		{
																			type: "field",
																			jsonPath:
																				"#.[?(@.remarks =~ /(.|\\s)*\\S(.|\\s)*/)]"
																		}
																	]
																},
																{
																	type: "static",
																	text: "1"
																}
															]
														},
														loop: null,
														filter: null,
														columnSizes: [
															15.0, 315.0
														],
														cells: [
															{
																type: "text",
																x: {
																	value: 0.0,
																	unit: "POINT"
																},
																y: {
																	value: 0.0,
																	unit: "POINT"
																},
																width: {
																	value: 15.0,
																	unit: "POINT"
																},
																height: {
																	value: 15.0,
																	unit: "POINT"
																},
																absolutePosition:
																	false,
																condition: null,
																loop: null,
																filter: null,
																text: {
																	type: "static",
																	text: "-"
																},
																font: "liberationsans-regular",
																fontSize: 10.0,
																fontColor: [
																	0.0, 0.0,
																	0.0
																],
																halign: "LEFT",
																valign: "TOP"
															},
															{
																type: "text",
																x: {
																	value: 0.0,
																	unit: "POINT"
																},
																y: {
																	value: 0.0,
																	unit: "POINT"
																},
																width: {
																	value: 315.0,
																	unit: "POINT"
																},
																height: {
																	value: 15.0,
																	unit: "POINT"
																},
																absolutePosition:
																	false,
																condition: null,
																loop: null,
																filter: null,
																text: {
																	type: "field",
																	jsonPath:
																		"#.remarks"
																},
																font: "liberationsans-italic",
																fontSize: 10.0,
																fontColor: [
																	0.0, 0.0,
																	0.0
																],
																halign: "LEFT",
																valign: "TOP"
															}
														]
													}
												]
											},
											{
												type: "composite",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 15.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: {
													type: "field",
													jsonPath:
														"$.[?((@.score && @.score != '')"
												},
												blocks: overviewScoreSquares
											},
											{
												type: "composite",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 95.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												blocks: [
													{
														type: "text",
														x: {
															value: 0.0,
															unit: "POINT"
														},
														y: {
															value: 0.0,
															unit: "POINT"
														},
														width: {
															value: 95.0,
															unit: "POINT"
														},
														height: {
															value: 15.0,
															unit: "POINT"
														},
														absolutePosition: false,
														condition: null,
														loop: null,
														filter: {
															type: "field",
															jsonPath:
																"$.[?((@.score && @.score != '')"
														},
														text: {
															type: "function",
															function: "lookup",
															arguments: [
																{
																	type: "field",
																	jsonPath:
																		"$.evaluation.scoreNames"
																},
																{
																	type: "function",
																	function:
																		"int",
																	arguments: [
																		{
																			type: "function",
																			function:
																				"-",
																			arguments:
																				[
																					{
																						type: "function",
																						function:
																							"int",
																						arguments:
																							[
																								{
																									type: "field",
																									jsonPath:
																										"#.score"
																								}
																							]
																					},
																					{
																						type: "function",
																						function:
																							"int",
																						arguments:
																							[
																								{
																									type: "static",
																									text: "1"
																								}
																							]
																					}
																				]
																		}
																	]
																}
															]
														},
														font: "liberationsans-regular",
														fontSize: 10.0,
														fontColor: [
															0.0, 0.0, 0.0
														],
														halign: "LEFT",
														valign: "MIDDLE"
													},
													{
														type: "text",
														x: {
															value: 0.0,
															unit: "POINT"
														},
														y: {
															value: 0.0,
															unit: "POINT"
														},
														width: {
															value: 95.0,
															unit: "POINT"
														},
														height: {
															value: 15.0,
															unit: "POINT"
														},
														absolutePosition: false,
														condition: {
															type: "function",
															function: "eq",
															arguments: [
																{
																	type: "function",
																	function:
																		"count",
																	arguments: [
																		{
																			type: "field",
																			jsonPath:
																				"#.[?(@.score && @.score != '')]"
																		}
																	]
																},
																{
																	type: "static",
																	text: "0"
																}
															]
														},
														loop: null,
														filter: null,
														text: {
															type: "static",
															text: "Behaald"
														},
														font: "liberationsans-regular",
														fontSize: 10.0,
														fontColor: [
															0.0, 0.0, 0.0
														],
														halign: "LEFT",
														valign: "MIDDLE"
													}
												]
											}
										]
									}
								]
							},
							{
								type: "composite",
								x: {
									value: 40.0,
									unit: "POINT"
								},
								y: {
									value: 20.0,
									unit: "POINT"
								},
								width: {
									value: 455.0,
									unit: "POINT"
								},
								height: {
									value: 0.0,
									unit: "POINT"
								},
								absolutePosition: false,
								condition: {
									type: "function",
									function: "neq",
									arguments: [
										{
											type: "function",
											function: "count",
											arguments: [
												{
													type: "field",
													jsonPath:
														"#.subsections..latestProperties..[?(@.offered=='true')]"
												}
											]
										},
										{
											type: "static",
											text: "0"
										}
									]
								},
								loop: null,
								filter: null,
								blocks: [
									{
										type: "text",
										x: {
											value: 0.0,
											unit: "POINT"
										},
										y: {
											value: 0.0,
											unit: "POINT"
										},
										width: {
											value: 455.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: null,
										filter: null,
										text: {
											type: "static",
											text: "Aangeboden competenties"
										},
										font: "liberationsans-bold",
										fontSize: 10.0,
										fontColor: [0.0, 0.0, 0.0],
										halign: "CENTER",
										valign: "TOP"
									},
									{
										type: "row",
										x: {
											value: 0.0,
											unit: "POINT"
										},
										y: {
											value: 15.0,
											unit: "POINT"
										},
										width: {
											value: 455.0,
											unit: "POINT"
										},
										height: {
											value: 15.0,
											unit: "POINT"
										},
										absolutePosition: false,
										condition: null,
										loop: {
											type: "field",
											jsonPath: "#.subsections"
										},
										filter: {
											type: "field",
											jsonPath:
												"$.latestProperties..[?(@.offered=='true')]"
										},
										columnSizes: [15.0, 395.0],
										cells: [
											{
												type: "text",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 15.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												text: {
													type: "static",
													text: "-"
												},
												font: "liberationsans-regular",
												fontSize: 10.0,
												fontColor: [0.0, 0.0, 0.0],
												halign: "LEFT",
												valign: "TOP"
											},
											{
												type: "text",
												x: {
													value: 0.0,
													unit: "POINT"
												},
												y: {
													value: 0.0,
													unit: "POINT"
												},
												width: {
													value: 395.0,
													unit: "POINT"
												},
												height: {
													value: 15.0,
													unit: "POINT"
												},
												absolutePosition: false,
												condition: null,
												loop: null,
												filter: null,
												text: {
													type: "field",
													jsonPath: "#.name"
												},
												font: "liberationsans-regular",
												fontSize: 10.0,
												fontColor: [0.0, 0.0, 0.0],
												halign: "LEFT",
												valign: "TOP"
											}
										]
									}
								]
							}
						]
					}
				]
			},
			{
				type: "text",
				x: {
					value: 0.0,
					unit: "POINT"
				},
				y: {
					value: 720.0,
					unit: "POINT"
				},
				width: {
					value: 240.0,
					unit: "POINT"
				},
				height: {
					value: 20.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Handtekening van de klastitularis"
				},
				font: "liberationsans-regular",
				fontSize: 10.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "LEFT",
				valign: "TOP"
			},
			{
				type: "text",
				x: {
					value: 255.0,
					unit: "POINT"
				},
				y: {
					value: 720.0,
					unit: "POINT"
				},
				width: {
					value: 240.0,
					unit: "POINT"
				},
				height: {
					value: 20.0,
					unit: "POINT"
				},
				absolutePosition: true,
				condition: null,
				loop: null,
				filter: null,
				text: {
					type: "static",
					text: "Handtekening van de ouder(s) of voogd"
				},
				font: "liberationsans-regular",
				fontSize: 10.0,
				fontColor: [0.0, 0.0, 0.0],
				halign: "RIGHT",
				valign: "TOP"
			}
		]
	}
];
